import { render } from "./PaymentsDetail.vue?vue&type=template&id=0a407744&ts=true"
import script from "./PaymentsDetail.vue?vue&type=script&lang=ts"
export * from "./PaymentsDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__